import {inject, Injectable} from '@angular/core';
import {messagesColor} from "../configs/config";
import {LoadingController, ToastController} from "@ionic/angular/standalone";

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  toastController: ToastController = inject(ToastController);
  loadingController: LoadingController = inject(LoadingController);
  constructor() { }

  async showToast(color: string, message: string) {
    const toast = await this.toastController.create({
      message,
      position: 'top',
      mode: 'ios',
      duration: 3000,
      color
    });
    await toast.present();
  }

  async showLoader(message: string) {
    const loader = await this.loadingController.create({
      message,
      mode: 'ios',
    });
    await loader.present();
  }
  dismissLoader() {
    this.loadingController.dismiss();
  }
}
